import styled from "styled-components";

import { Container } from "components/ui";

import { media } from "constants/media";

export const StyledVacatureDetailPage = styled.div`
    position: relative;
`;

export const Background = styled.div`
    background-image: url("/images/vacancy-detail-bg-mobile.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 2200px;
    position: absolute;
    top: -50%;
    width: 100%;
    z-index: -1;

    ${media.mdUp} {
        background-image: url("/images/vacancy-detail-bg-desktop.webp");
        height: 2260px;
        top: -24%;
    }
`;

export const ButtonAndHeart = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 18px;
    margin: 24px 0;

    ${media.mdUp} {
        align-items: center;
        margin: 0 0 40px;
    }
`;

export const IconsWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: center;
    width: 100%;

    ${media.mdUp} {
        flex-direction: row;
        width: auto;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    white-space: nowrap;
    width: 100%;

    ${media.mdUp} {
        flex-direction: row;
        width: auto;
    }
`;

export const ShareThisPopup = styled.div`
    align-items: center;
    background: var(--color-white);
    border-radius: 32px;
    bottom: 100%;
    cursor: pointer;
    display: flex;
    gap: 12px;
    left: 0;
    opacity: 0;
    padding: 8px 24px 5px;
    position: absolute;
    transform: translateX(-60%);
    transition: all 0.3s ease-in-out;

    &.active {
        bottom: calc(100% + 16px);
        opacity: 1;
    }

    svg {
        cursor: pointer;
    }

    a svg {
        margin-right: 0;
    }

    ${media.mdUp} {
        bottom: -9px;
        left: 100%;
        right: unset;
        transform: translateX(-50%);
        transform: none;

        &.active {
            bottom: -9px;
            left: calc(100% + 16px);
        }
    }
`;

export const IconWrapper = styled.div<{ saveVacancy?: boolean }>`
    align-items: center;
    display: flex;
    margin-bottom: ${({ saveVacancy }) => (saveVacancy ? "0" : "16px")};
    position: relative;

    svg {
        cursor: pointer;
        margin-right: 8px;
    }

    span {
        color: var(--color-white);
        font-size: var(--type-heading-4-font-size);
        font-weight: 500;
        margin-right: 8px;
    }
`;

export const Info = styled.p`
    max-width: 576px;

    ${media.mdUp} {
        max-width: 50%;
    }
`;

export const IconContainer = styled.div`
    ${media.mdUp} {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin: 24px 0;
    }

    ${media.lgUp} {
        gap: 24px;
    }
`;

export const StyledContainer = styled(Container)`
    flex-direction: column;
    margin-top: 188px;

    ${media.mdUp} {
        margin-top: 0;
    }

    ${media.xlUp} {
        margin-top: 0;
    }
`;

export const Title = styled.h1`
    font-size: 32px;
    hyphens: auto;
    margin-bottom: 24px;
    word-break: auto-phrase;

    ${media.mdUp} {
        font-size: 40px;
        line-height: 60px;
        margin-bottom: 0;
        /* width: 70%; */
    }
`;

export const Department = styled.div<{ department?: boolean }>`
    background: ${({ department }) =>
        department ? "var(--color-grey-50)" : ""};
    border-radius: 16px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 1px;
    line-height: 16px;
    margin: 24px 0;
    padding: 4px 8px;
    text-transform: uppercase;
    width: fit-content;

    ${media.mdUp} {
        margin: 80px 0 32px;
    }
`;

export const DescriptionHeading = styled.h2`
    font-size: 28px;

    ${media.mdUp} {
        font-size: 32px;
    }
`;

export const Description = styled.article<{ ulNoMargin?: boolean }>`
    margin-bottom: 24px;

    p {
        margin-bottom: 16px;
    }

    strong span {
        font-family: var(--font-secondary);
        font-size: 32px !important; //inline-styling from API
        font-weight: 800;
        line-height: 48px;

        ${media.mdUp} {
            font-size: 40px !important; //inline-styling from API
            line-height: 64px;
        }
    }

    ul {
        list-style: none;
        margin: ${({ ulNoMargin }) => (ulNoMargin ? "0" : "24px 0")};

        li {
            align-items: center;
            display: flex;
            margin-bottom: 16px;

            p {
                margin-bottom: 0;
            }

            &::before {
                content: url("/images/arrow.svg");
                margin: 8px 0 0;
                min-height: 24px;
                min-width: 24px;
            }
        }
    }

    ${media.mdUp} {
        margin: 0 auto 88px 0;
        max-width: unset;
    }
`;

export const TopSection = styled.div`
    display: flex;

    ${media.mdUp} {
        flex-direction: row;
    }
`;

export const TopLeftSection = styled.div`
    ${media.mdUp} {
        width: 50%;
    }

    ${media.lgUp} {
        width: 55%;
    }
`;

export const TopRightSection = styled.div`
    ${media.mdUp} {
        width: 50%;
    }

    ${media.lgUp} {
        height: 560px;
        width: 45%;
    }
`;
